import { TeamResponse } from 'lib/teams';
import { insertIf, insertIfElse, join } from 'lib/helpers';
import { usePlanStatusFromResponse } from 'components/profile/usePlanStatus';
import { ViewTeamButton } from './AccountActions';
import AccountDivider from './AccountDivider';
import styles from './AccountPlanRow.module.css';

interface Props {
  team: TeamResponse;
  divider?: boolean;
}

interface BadgeProps {
  team: TeamResponse;
}

const adminPermissions = new Set(['Owner', 'Admin']);

const TeamBadge = ({ team }: BadgeProps) => {
  if (team.isFreeTeam === true) {
    return <></>;
  }
  if (team.isEnterprise) {
    return (
      <div className={join([styles.Badge, styles.BadgeEnterprise])}>
        ENTERPRISE
      </div>
    );
  }
  if (team.planCode === 'TEAM') {
    return (
      <div className={join([styles.Badge, styles.BadgeVoyager])}>VOYAGER</div>
    );
  }

  return <div className={join([styles.Badge, styles.BadgeLegacy])}>LEGACY</div>;
};

const AccountPlanRow = ({ team, divider = true }: Props) => {
  const isAdmin = adminPermissions.has(team.permission);

  const { isActive, isCancelled, displayLabel, formattedDue } =
    usePlanStatusFromResponse(team);

  return (
    <>
      <div className={styles.Row}>
        <div className={styles.AvatarContainer}>
          <img
            className={join([
              styles.Avatar,
              ...insertIf(!team.avatar, styles.AvatarFallback),
            ])}
            src={team.avatar ?? '/static/upload.png'}
            alt="Avatar"
          />
        </div>
        <div className={styles.InnerGrid}>
          <div className={styles.TeamName}>
            <h3>{team.name}</h3>
            <TeamBadge team={team} />
          </div>
          <ViewTeamButton isAdmin={isAdmin} teamId={team.ownerId} />
          <h4
            className={join([
              ...insertIfElse(isActive, styles.Green, styles.Red),
              ...insertIf(isActive && isCancelled, styles.Amber),
            ])}
          >
            {displayLabel}{' '}
            {isActive && isCancelled ? `(ends ${formattedDue})` : ''}
          </h4>
        </div>
      </div>
      {divider && <AccountDivider />}
    </>
  );
};

export default AccountPlanRow;
